console.debug("KD - Stylish Tabbed Content 2");
var kdSTC2_usingDropdown = false;
function kdSTC2_clickedTab(a) {
  let i = Number(a.dataset.tabi);
  console.debug("Clicked Tab #" + (1 + i));
  // set button text
  jQuery("button.kdsts span").text(a.innerHTML);
  // tabs: remove active
  let li = jQuery("div.kdSTC2 > nav > ul > li");
  li.removeClass("active");
  // tab: add active
  li.eq(i).addClass("active");
  // panel: remove active
  jQuery("section.tabPanel").removeClass("active");
  // panel: add active
  let p = jQuery("section.tabPanel" + i);
  p.addClass("active");

  // hide nav list when using dropdown mode
  if (kdSTC2_usingDropdown) {
    //jQuery('div.kdSTC2 > nav > ul').css('display', 'none');
    jQuery("div.kdSTC2 > nav > ul").removeClass("open");
  }

  // scroll
  window.scroll({
    top:
      document.querySelector("div.kdSTC2_TOP").offsetTop -
      (window.innerWidth < 769 ? 96 : 220),
    left: 0,
    behavior: "smooth",
  });

  // images
  kdSTC2_showImages(i);
}

function kdSTC2_clickedNavBtn(btn) {
  console.debug("kdSTC2_clickedNavBtn");
  kdSTC2_usingDropdown = true;
  jQuery("div.kdSTC2 > nav > ul").toggleClass("open");
}

function kdSTC2_showImages(t) {
  console.debug('function kdSTC2_showImages: ' + t);
  jQuery('.kdSTC2_tab_images > div').removeClass('in');
  jQuery('.kdSTC2_tab_images > div.t' + t).addClass('in');
}

// DOM Ready
window.addEventListener('DOMContentLoaded',function () {
  let j = jQuery('.kdSTC2-btn');
  j.map(function(i, ob) {
    let jj = jQuery(this);
    jj.addClass(i%2==0?'btnL':'btnR');
    jj.parent().addClass(i%2==0?'btnL':'btnR');
  });
});






















//